/**
 * Tri naturel par morceaux : les nombres sont comparés en tant qu’entiers.
 * « 1 - FINANCE », « 2 - … », « 10 - … » et non 1, 10, 11, 2.
 */

export function naturalCompare(a: string, b: string): number {
  const aParts = String(a).match(/(\d+)|(\D+)/g) ?? [String(a)];
  const bParts = String(b).match(/(\d+)|(\D+)/g) ?? [String(b)];
  const n = Math.max(aParts.length, bParts.length);
  for (let i = 0; i < n; i++) {
    const ap = aParts[i] ?? "";
    const bp = bParts[i] ?? "";
    const aNum = /^\d+$/.test(ap);
    const bNum = /^\d+$/.test(bp);
    if (aNum && bNum) {
      const d = Number(ap) - Number(bp);
      if (d !== 0) return d;
      continue;
    }
    const d = ap.localeCompare(bp, "fr", { sensitivity: "base" });
    if (d !== 0) return d;
  }
  return 0;
}

export function naturalSortByCode<T extends { code: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => naturalCompare(a.code, b.code));
}

export function naturalSortByDomain<T extends { domain: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => naturalCompare(a.domain, b.domain));
}

export function sortCampaignsByYearAndDomain<T extends { year: number; domain: string }>(
  items: T[]
): T[] {
  return [...items].sort((a, b) => b.year - a.year || naturalCompare(a.domain, b.domain));
}
